import Vue from 'vue';
import Router from 'vue-router';

const Index = () => import('./views/Index');
const Home = () => import('./views/Home/Home');
const ENHome = () => import('./views/Home/ENHome');
const Info = () => import('./views/Info/Info');
const ENInfo = () => import('./views/Info/ENInfo');
const Terms = () => import('./views/Home/Terms');
const PersonalData = () => import('./views/Home/PersonalData');
const Login = () => import('./views/Login/Login');
const Smart = () => import('./views/Brewery/Smart');
const ENSmart = () => import('./views/Brewery/ENSmart');
const ENNano = () => import('./views/Brewery/ENNano');
const Nano = () => import('./views/Brewery/Nano');
const News = () => import('./views/News/News');
const ENNews = () => import('./views/News/ENNews');
const DetailNews = () => import('./views/News/DetailNews');
const ENDetailNews = () => import('./views/News/ENDetailNews');
const Store = () => import('./views/Store/Store');
const ENStore = () => import('./views/Store/ENStore');
const DetailStore = () => import('./views/Store/DetailStore');
const ENDetailStore = () => import('./views/Store/ENDetailStore');
const Contact = () => import('./views/Contact/Contact');
const ENContact = () => import('./views/Contact/ENContact');
const Admin = () => import('./views/Admin/Admin');
const Main = () => import('./views/Admin/Main');
const PopUp = () => import('./views/Admin/PopUp/PopUp');
const PopUpWrite = () => import('./views/Admin/PopUp/PopUpWrite');
const PopUpEdit = () => import('./views/Admin/PopUp/PopUpEdit');
const History = () => import('./views/Admin/History/History');
const HistoryWrite = () => import('./views/Admin/History/HistoryWrite');
const HistoryDetail = () => import('./views/Admin/History/HistoryDetail');
const HistoryEdit = () => import('./views/Admin/History/HistoryEdit');
const BeerCard = () => import('./views/Admin/BeerCard/BeerCard');
const BeerCardDetail = () => import('./views/Admin/BeerCard/BeerCardDetail');
const BeerCardEdit = () => import('./views/Admin/BeerCard/BeerCardEdit');
const BeerCardWrite = () => import('./views/Admin/BeerCard/BeerCardWrite');
const AdminNews = () => import('./views/Admin/News/News');
const NewsDetail = () => import('./views/Admin/News/NewsDetail');
const NewsEdit = () => import('./views/Admin/News/NewsEdit');
const NewsWrite = () => import('./views/Admin/News/NewsWrite');
const AdminStore = () => import('./views/Admin/Store/Store');
const StoreDetail = () => import('./views/Admin/Store/StoreDetail');
const StoreEdit = () => import('./views/Admin/Store/StoreEdit');
const StoreWrite = () => import('./views/Admin/Store/StoreWrite');
const AdminContact = () => import('./views/Admin/Contact/Contact');
const ContactDetail = () => import('./views/Admin/Contact/ContactDetail');
const Visitor = () => import('./views/Admin/Visitor/Visitor');
const NotFound = () => import('./views/Guide/NotFound');
const ContactImagePopup = () => import('./views/Home/ContactImagePopup');

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/home',
    },
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/en/home',
      name: 'en-home',
      component: ENHome,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/info',
      name: 'info',
      component: Info,
    },
    {
      path: '/en/info',
      name: 'en-info',
      component: ENInfo,
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },
    {
      path: '/en/terms',
      name: 'en-terms',
      component: Terms,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: PersonalData,
    },
    {
      path: '/contact-popup',
      name: 'contact-popup',
      component: ContactImagePopup,
    },
    {
      path: '/en/privacy',
      name: 'en-privacy',
      component: PersonalData,
    },
    {
      path: '/smart',
      name: 'smart',
      component: Smart,
    },
    {
      path: '/nano',
      name: 'nano',
      component: Nano,
    },
    {
      path: '/en/smart',
      name: 'en-smart',
      component: ENSmart,
    },
    {
      path: '/en/nano',
      name: 'en-nano',
      component: ENNano,
    },
    {
      path: '/news',
      component: News,
      name: 'news',
    },
    {
      path: '/en/news',
      component: ENNews,
      name: 'en-news',
    },
    {
      path: '/news/detail/:id',
      name: 'detail-news',
      component: DetailNews,
    },
    {
      path: '/en/news/detail/:id',
      name: 'en-detail-news',
      component: ENDetailNews,
    },
    {
      path: '/store',
      name: 'store',
      component: Store,
    },
    {
      path: '/store/detail/:id',
      name: 'detail-store',
      component: DetailStore,
    },
    {
      path: '/en/store',
      name: 'en-store',
      component: ENStore,
    },
    {
      path: '/en/store/detail/:id',
      name: 'en-detail-store',
      component: ENDetailStore,
    },
    {
      path: '/contact',
      component: Contact,
      name: 'contact',
    },
    {
      path: '/en/contact',
      component: ENContact,
      name: 'en-contact',
    },
    {
      path: '/error',
      component: NotFound,
      name: 'not-found',
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: '',
          name: 'admin',
          component: Main,
        },
        {
          path: 'popup',
          name: 'popup-admin',
          component: PopUp,
        },
        {
          path: 'popup/write',
          name: 'popup-write-admin',
          component: PopUpWrite,
        },
        {
          path: 'popup/edit/:idx',
          name: 'popup-edit-admin',
          component: PopUpEdit,
        },
        {
          path: 'history',
          name: 'history-admin',
          component: History,
        },
        {
          path: 'history/write',
          name: 'history-write-admin',
          component: HistoryWrite,
        },
        {
          path: 'history/:idx',
          name: 'history-detail-admin',
          component: HistoryDetail,
        },
        {
          path: 'history/edit/:idx',
          name: 'history-edit-admin',
          component: HistoryEdit,
        },
        {
          path: 'beer',
          name: 'beer-admin',
          component: BeerCard,
        },
        {
          path: 'beer/write',
          name: 'beer-write-admin',
          component: BeerCardWrite,
        },
        {
          path: 'beer/:idx',
          name: 'beer-detail-admin',
          component: BeerCardDetail,
        },
        {
          path: 'beer/edit/:idx',
          name: 'beer-edit-admin',
          component: BeerCardEdit,
        },
        {
          path: 'news',
          name: 'news-admin',
          component: AdminNews,
        },
        {
          path: 'news/write',
          name: 'news-write-admin',
          component: NewsWrite,
        },
        {
          path: 'news/:id',
          name: 'news-detail-admin',
          component: NewsDetail,
        },
        {
          path: 'news/edit/:id',
          name: 'news-edit-admin',
          component: NewsEdit,
        },
        {
          path: 'store',
          name: 'store-admin',
          component: AdminStore,
        },
        {
          path: 'store/write',
          name: 'store-write-admin',
          component: StoreWrite,
        },
        {
          path: 'store/:id',
          name: 'store-detail-admin',
          component: StoreDetail,
        },
        {
          path: 'store/edit/:id',
          name: 'store-edit-admin',
          component: StoreEdit,
        },
        {
          path: 'contact',
          name: 'contact-admin',
          component: AdminContact,
        },
        {
          path: 'contact/:id',
          name: 'contact-detail-admin',
          component: ContactDetail,
        },
        {
          path: 'visitor',
          name: 'visitor-admin',
          component: Visitor,
        }
      ],
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
